import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('STATUS_COMMENT').plugin(axiosPlugin);

let fetchStatusCommentAction = redux.fetchActionGetOne();

let createStatusCommentAction = redux.fetchActionCreate();

let updateStatusCommentAction = redux.fetchActionUpdate();

let deleteStatusCommentAction = redux.fetchActionDelete();

export const TYPES = redux.types;

export const fetchStatusComment = (userId, statusId, commentId, query = {}) => fetchStatusCommentAction(`/users/${userId}/status/${statusId}/comments/${commentId}?${queryString.stringify(query)}`);
export const createStatusComment = (userId, statusId, data) => createStatusCommentAction(`/users/${userId}/status/${statusId}/comments`, data);
export const updateStatusComment = (userId, statusId, commentId, data = {}) => updateStatusCommentAction(`/users/${userId}/status/${statusId}/comments/${commentId}`, data);
export const deleteStatusComment = (userId, statusId, commentId = {}) => deleteStatusCommentAction(`/users/${userId}/status/${statusId}/comments/${commentId}`);
export const resetStatusComment = () => redux.actions.reset();

export const statusComment = redux.reducer();